import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IL1ServiceListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setL1ServiceSetupList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
export const useL1ServiceListAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();

  const execute = useCallback(async (serviceTypeId?: string | null) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const query = new URLSearchParams({ section: "only_service" });
      if (serviceTypeId) {
        query.set("service_type_id", serviceTypeId);
      }

      await axios
        .get(`${CONFIGURATION_APIS?.SERVICE_ONBOARD?.baseURL}?${query.toString()}`, {
          headers: {
            Authorization: accessToken,
          },
        })
        .then((res: AxiosResponse<IL1ServiceListResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setL1ServiceSetupList({
                data: res.data.data,
              }),
            );
          } else {
            toast.error("Error while fetching services list.");
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error at server while fetching city details.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return execute;
};
